import React, { useEffect } from 'react';
import styled from 'styled-components';

import useInterval from '../hooks/useInterval';

import iconSVG from '../data/images/map.svg';

import { colors, fonts } from '../GlobalStyle';
import { calc4k } from '../utilities';

const SLIDER_OFFSET = 690;
const TIMER_INTERVAL = 10000;

const EVENTS_INTERVAL = 1000 * 60 * 15;

export default function CardSlider({ events, offset, title, height, position, noEventsText, disableTitlePadding }) {
    const [currEventIdx, setCurrEventIdx] = React.useState(0);

    const setEvents = () => {
        const nowTime = new Date().getTime();
        const targetTime =
                  events[currEventIdx] &&
                  new Date(events[currEventIdx].startTime).getTime();
        const targetTimePlusInterval =
                  targetTime && new Date(targetTime + EVENTS_INTERVAL).getTime();
        const timeToSwitchEvent = targetTimePlusInterval < nowTime;

        let nextEventIncrement = 1;

        events.forEach( event => {
            const nextTargetTime =
                      event &&
                      new Date(event.startTime).getTime();
            const nextTargetTimePlusInterval =
                      nextTargetTime && new Date(nextTargetTime + EVENTS_INTERVAL).getTime();

            const nextTimeToSwitchEvent = nextTargetTimePlusInterval < nowTime;
            if( nextTimeToSwitchEvent ) {
                nextEventIncrement++;
            }
        });

        if (timeToSwitchEvent) setCurrEventIdx(s => nextEventIncrement );
    };

    useInterval(() => {
        setEvents();
    }, TIMER_INTERVAL );

    useEffect( () => {
        setEvents();
    }, [] );

    return (
        <Container
            height={height}
            position={position}
            offset={offset ? 1 : 0}
           >
            {title ? <Title disableTitlePadding={disableTitlePadding} offset={ offset ? 1 : 0 }>{title}</Title> : null}
            {
                !events.length || currEventIdx >= events.length ? (
                    <NoEvents>{noEventsText}</NoEvents>
                ) : null
            }
            <Content style={{
                position: 'relative',
                transition: 'transform 600ms ease-in-out',
                transform: `translate(-${calc4k(SLIDER_OFFSET * currEventIdx)})`
            }}>
                {
                    events.map((e, idx) => {
                        return (
                            <Card key={idx}>
                                <ImageContainer>
                                    <Image src={e.img} />
                                    <Time>
                                        <span>{e.displayTime}</span>
                                        {e.displayTimePeriod}
                                    </Time>
                                </ImageContainer>
                                <EventType isMonthDay={e.typeIsMonthDay}>{e.type}</EventType>
                                <EventTitle>{e.title}</EventTitle>
                                {e?.location ? (
                                    <EventDetails>
                                        <Icon src={iconSVG} />
                                        {e.location}
                                    </EventDetails>
                                ) : null}                                
                            </Card>
                        );
                    })
                }
            </Content>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    position: ${ p => p.position ? p.position : 'absolute' };
    top: ${p => (p.offset ? calc4k(-340) : 0)};
    height: ${p => (p.height ? p.height : calc4k(956))};
    padding-left: ${calc4k(90)};
    flex-direction: column;
`;

const Content = styled.div`
    //height: 100%;
    display: flex;
    position: relative;
    min-height: 100%;
`;

const Title = styled.div`
    color: white;
    font-size: ${calc4k(50)};
    font-weight: 500;
    text-transform: uppercase;
    //margin-bottom: ${calc4k(96)};
    padding-top: ${calc4k(96)};
    padding-bottom: ${calc4k(96)};
    min-height: ${calc4k(265)};
    //padding-bottom: ${ p => p.disableTitlePadding ? 0 : calc4k(96)};
    color: #d8d8d8;
    //margin-top: ${ p => p.offset ?  calc4k(-96) : 0 };
`;

const Card = styled.div`
    position: relative;
    max-width: ${calc4k(600)};
    display: flex;
    flex-direction: column;
    margin-right: ${calc4k(90)};
`;

const EventType = styled.div`
    text-transform: uppercase;
    color: ${ p => p.isMonthDay ? '#d8b271' : '#afafaf' };
    margin-top: ${calc4k(22)};
    font-size: ${ p => p.isMonthDay ? calc4k(60) : calc4k(36)};
    font-weight: 500;
    font-family: ${fonts.headline};
    letter-spacing: ${calc4k(1)};
    line-height: ${ p => p.isMonthDay ? calc4k(110) : calc4k(78)};
    margin-bottom: ${ p => p.isMonthDay ?  calc4k(20) : 0 };
`;
const EventTitle = styled.div`
    font-size: ${calc4k(60)};
    font-weight: 500;
    font-family: ${fonts.headline};
    letter-spacing: ${calc4k(1)};
    line-height: ${calc4k(78)};
    margin-bottom: ${calc4k(27)};
`;
const EventDetails = styled.div`
    color: #ffffff;
    font-size: ${calc4k(40)};
    line-height: ${calc4k(42)};
    font-family: ${fonts.body};
`;

const Icon = styled.img`
    height: ${calc4k(40)};
    width: auto;
    margin-right: ${calc4k(19)};
`;

const ImageContainer = styled.div`
    position: relative;
    height: ${calc4k(500)};
`;

const Image = styled.img`
    height: ${calc4k(500)};
    width: ${calc4k(600)};
`;

const Time = styled.div`
    background-color: black;
    position: absolute;
    bottom: -${calc4k(3)};
    color: #ffffff;
    font-family: ${fonts.headline};
    font-size: ${calc4k(32)};
    font-weight: 500;
    text-transform: uppercase;
    padding-right: ${calc4k(50)};
    padding-top: ${calc4k(20)};

    span {
        font-size: ${calc4k(80)};
        font-weight: 500;
        font-family: ${fonts.headline};
    }
`;

const NoEvents = styled.h1`
    font-size: ${calc4k(60)};
    position: absolute;
    top: 50%;
    left: calc( 50% - ${calc4k(90)} );
    transform: translate(-50%,-50%);
    color: white;
`;